import { render, staticRenderFns } from "./ServiceSubcategoriesTable.vue?vue&type=template&id=b9c2d8b2"
import script from "./ServiceSubcategoriesTable.vue?vue&type=script&lang=js"
export * from "./ServiceSubcategoriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports